import React, { useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import TwoFa from "../../elements/twoFa/TwoFa";
import DialogModal from "../../elements/dialogModal/DialogModal";
import { TextField } from "@material-ui/core";
import DefaultButton from "../../styles/materialButtonStyle";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";

import { StyledBlockAction, StyledInputBlock } from "../../styles/styledTabsForm";

const BlockchainUrlEditForm = ({ blockchainUrl, notification, setNotification }) => {
  const { t } = useTranslation("blockchainUrlPage");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    value: null
  });

  const handleSave = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put("/api/currency-settings/" + blockchainUrl.id, submitData, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("details.changeForm.success") });
      }
    }).catch(error => {
      setOpen(false);
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("details.changeForm.twoFa")}
        content={<TwoFa
          handleSubmit={handleSave}
          error={error}
        />}
      />
      <StyledInputBlock
        as="form"
        onSubmit={event => {
          event.preventDefault();
          setSubmitData({
            ...setSubmitData,
            value: event.target.blockchainUrl.value
          });
          setOpen(true);
        }}
      >
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("details.changeForm.link")}
          id="blockchainUrl"
          type="text"
          name="blockchainUrl"
          defaultValue={blockchainUrl.value}
        />
        <StyledBlockAction>
          <DefaultButton
            color="success"
            type="submit"
          >
            {t("details.changeForm.save")}
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </>
  );
};

export default BlockchainUrlEditForm;